import React from 'react';
import Table from '../../../components/table';

import { sectionHead } from './_common';
import { FormattedMessage } from 'react-intl';
import messages from '../../../text/messages';
import { getFullName, getAddress, formatMoney } from '../../../utilities/string';
import { dateToFloatingString } from '../../../utilities/dateTime';
import { ifExists } from '../../../utilities/string';
import { getTypeMessage, getProjectsRateLabelAndValue, renderProjectRate } from '../../../utilities/rate';
import { TerminateButton, DeleteAssignmentButton } from '../../../components/richButtons';
import ExtendButton from '../../../components/richButtons/extendButton';
import { formatPhoneNumberIntl } from 'react-phone-number-input';
import { getClassificationPrefName } from '../../../text/selectOptions';

class AssignmentTab extends React.Component {
    render() {
        const { admin, job, handleDelete, handleTerminate, projects, reload } = this.props;
        const { start_date, end_date, status, work_location_address, po_value, rate_currency, pay_type, hm = {} } = job;
        const contractPeriod = (
            <span>{`${dateToFloatingString(start_date, 'MMMM D, YYYY')} - ${end_date ? dateToFloatingString(end_date, 'MMMM D, YYYY') : ' '}`}</span>
        );

        const paymentTypeMessage = getTypeMessage(pay_type);

        const payRateOrAmount = getProjectsRateLabelAndValue(job, projects);
        const projectsList = projects.map(p => renderProjectRate(pay_type, p)).join(', ');
        const hideProjects = job.rate && projects.length < 2;

        const started = status === 'active' && new Date(start_date) <= new Date();
        let jobStatus = status;
        if (jobStatus === 'active') {
            jobStatus += started ? '/started' : ' (not yet started)';
        }
        if (!jobStatus) {
            jobStatus = 'none';
        }

        const client_pref = jobStatus === 'pending' && {
            label: <FormattedMessage {...messages.classifyClientPreference} />,
            value: getClassificationPrefName(admin, job.classify_client_pref)
        };

        const tableData = {
            columns: [
                { valueMap: d => <span className="row-label">{d.label}</span>, size: 'col-xs-12 col-md-3' },
                { valueMap: d => <span className="row-value">{d.value}</span>, size: 'col-xs-12 col-md-9' }
            ],
            data: [
                sectionHead(messages.theWork, true),
                { label: <FormattedMessage {...messages.status} />, value: jobStatus },
                { label: <FormattedMessage {...messages.title} />, value: job.title },
                { label: <FormattedMessage {...messages.detailedDescription} />, value: job.description },
                { label: <FormattedMessage {...messages.department} />, value: job.department || '-' },
                { label: <FormattedMessage {...messages.contractPeriod} />, value: contractPeriod },
                { label: <FormattedMessage {...messages.workLocation} />, value: getAddress(work_location_address) },
                sectionHead(messages.thePay),
                ...ifExists(client_pref),
                {
                    label: <FormattedMessage {...messages.classifyResult} />,
                    value: <span className="uppercase">{job.classify_result}</span>
                },
                {
                    label: <FormattedMessage {...messages.paymentType} />,
                    value: <FormattedMessage {...paymentTypeMessage} />
                },
                ...(hideProjects ? [payRateOrAmount] : [{ label: <FormattedMessage {...messages.projects} />, value: projectsList }]),
                { label: <FormattedMessage {...messages.hoursPerWeek} />, value: job.hours_per_week || '-' },
                { label: <FormattedMessage {...messages.poNumber} />, value: job.po_number || '-' },
                { label: <FormattedMessage {...messages.poValue} />, value: po_value ? formatMoney(po_value, rate_currency) : '-' },

                sectionHead(messages.theManager),
                { label: <FormattedMessage {...messages.name} />, value: getFullName(hm) },
                { label: <FormattedMessage {...messages.phone} />, value: hm.phone ? formatPhoneNumberIntl(hm.phone) : '-' },
                { label: <FormattedMessage {...messages.email} />, value: hm.email || '-' }
            ]
        };

        const showDelete = job.id && handleDelete;
        const showTerminate = job.id && job.status !== 'inactive' && handleTerminate;
        const showExtend = job.id && job.status !== 'inactive';
        return (
            <div>
                <Table {...tableData} rowStyle={'onboarding-table-row'} />
                <div className="row topOffset15">
                    <div className="col-xs-12 topOffset15">
                        {showDelete && <DeleteAssignmentButton job={job} handleDelete={handleDelete} />}
                        {showDelete && <span className="button buttonSpacer">SPC</span>}
                        {showTerminate && <TerminateButton job={job} handleTerminate={handleTerminate} />}
                        {showTerminate && <span className="button buttonSpacer">SPC</span>}
                        {showExtend && <ExtendButton worker={job} onSuccess={reload} {...this.props} message={messages.edit} />}
                    </div>
                </div>
            </div>
        );
    }
}

AssignmentTab.defaultProps = {
    handleDelete: null,
    handleTerminate: null,
    job: {},
    projects: [],
    projectsOptions: []
};

export default AssignmentTab;



// WEBPACK FOOTER //
// ./src/pages/worker/tabs/assignment.jsx